import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FormButton from "../../../Components/Buttons/FormButton";
import Table, { Column } from "../../../Components/Tables/Table";
import { HistoryLaoutTransferDetails, transferdetailslist } from "../../../Data/testData";
import PageHeader from "../../../Layout/PageHeader";
import historyIcon from "../../../assets/images/history-icon.svg";
import DynamicDetailGrid from "../../../Components/Grid/DynamicDetailGrid";
import HistoryLayout from "../../../Layout/HistoryLaout";

export default function TransferDetails() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const pageName = `Stock Transfer (${id})`;
  const [collapseStates, setCollapseStates] = useState<boolean[]>([false]);
  const toggleCollapse = (index: number) => {
    const updatedCollapseStates = [...collapseStates];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates(updatedCollapseStates);
  };

  const [isShowCanvas, setShowCanvas] = useState(false);
  const handelCanvas = () => {
   setShowCanvas(!isShowCanvas);
  };
  const historyData = (
    <>
      <div
        className="d-flex justify-content-between w-100 align-items-center px-4"
        onClick={handelCanvas}
      >
        <div>
          <h6 className="cursor-pointer m-0 d-flex align-items-center">
            <img src={historyIcon} className="me-2" />
            History
          </h6>
        </div>
      </div>
    </>
  );
  const columns: Column[] = [
    {
      name: "Line#",
      selector: (row: { line: string }) => row.line,
    },
    {
      name: "Item Code",
      selector: (row: { itemCode: string }) => row.itemCode,
    },
    {
      name: "Item Description",
      selector: (row: { itemDesc: string }) => (
        <span   title={row.itemDesc.length > 15 ? row.itemDesc : ""}>
        {row.itemDesc.length > 15
          ? `${row.itemDesc.slice(0, 15)}...`
          : row.itemDesc}
      </span>
      ),
    },
    {
      name: "UOM",
      selector: (row: { uom: string }) => row.uom,
    },
    {
      name: "From",
      selector: (row: { from: string }) => row.from,
    },
    {
      name: "To",
      selector: (row: { to: string }) => row.to,
    },
    {
      name: "Actual Qty",
      selector: (row: { actualQty: number }) => row.actualQty,
    },
    {
      name: "Transferred Qty",
      selector: (row: { transferredQty: number }) => row.transferredQty,
    },
  ];

  const StockTransferData=[
    {label: "Transfer Date", value: "03/15/2023"},
    {label: "From Inventory Status", value: "Finished Goods"},
    {label: "To Inventory Status", value: "Found Inventory"},
    {label: "Custom Field 1", value: "-"},
    {label: "Custom Field 2", value: "-"},
    {label: "Created On", value: "03/15/2023"},
    {label: "No. of Lines", value: "6"},
    {label: "Transfer By", value: "By Item"},
    {label: "Assigned To", value: "Drake"},
    { label: 'Status', value: (
        <>
            <div className="text-dark w-auto px-4 badge asn-overview-status w-70 asn-overview-status-border-blue">
                New
            </div>
        </>
    )
    }
]
  return (
    <>
      <PageHeader
        addUrl="/inbound/asn/overview/add"
        listUrl="/inventory/stock-transfer"
        viewType={true}
        isHistoryEnabled={true}
        historyData={[historyData]}
      />
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="my-2 bg-white rounded py-1 px-2">

        <div className="bg-white rounded py-1 px-2 d-flex flex column">
        <DynamicDetailGrid customClassName=" col-10" isExpandable={false} columns={3} data={StockTransferData} />
        </div>
      </div>
      <div className="my-2 bg-white rounded py-1 px-2">
        <Table
          columns={columns}
          data={transferdetailslist}
          CheckboxStatus={false}
          isStripped  = {true}
          customClassName="transferDetailsTable"
        />
      </div>
      <div className="my-2 bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton
            tabIndex={11}
            className="sph-btn me-4"
            handleClick={() => {
              navigate(`/inventory/stock-transfer/transfer-edit/${id}`);
            }}
          >
            Edit
          </FormButton>
        </div>
      </div>

      <HistoryLayout showViewScanLogs={true}  isShowCanvas={isShowCanvas} handelCanvas={handelCanvas} data={HistoryLaoutTransferDetails} />

    </>
  );
}
